import AdvancePagination from "../../../components/common/AdvancePagination";
import Products from "../../../components/monaliza/product/Products";
import {Container, Col, Row} from "react-bootstrap";
import { Empty } from "antd"
import { SHAPE_KANBAN, SHAPE_LIST } from "../../../enums/Enum";
import { useSelector } from 'react-redux';
import { selectFavorites } from "../../../app/store/reducers/main/mainReducer";
import Product from "../../../components/monaliza/product/Product";

const FavoriteList = () => {
  const favorites = useSelector(selectFavorites)
  const shape = SHAPE_KANBAN



  return (
    <>
      <Container>
        {/* <Row> */}
          <h1>Избранные товары</h1>
          {favorites?.length > 0 ?
            <Row className="border border-2 mb-4 justify-content-center">
            {/* {favorites?.map((item) => {
                return (
                    <Col key={item?.id}
                xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
                lg={SHAPE_LIST === shape ? 12 : 4} 
                md={SHAPE_LIST === shape ? 12 : 6} 
                sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
                <Product item={item} shape={shape}/>
            </Col>
                )
            })} */}


            {favorites?.map((product) => {
                return (
                    <Col key={product?.id}
                xs={12} xl={SHAPE_LIST === shape ? 12 : 3} 
                lg={SHAPE_LIST === shape ? 12 : 4} 
                md={SHAPE_LIST === shape ? 12 : 6} 
                sm={SHAPE_LIST === shape ? 12 : 7} className="my-1">
                <Product product={product} shape={shape}/>
            </Col>
                )
            })}
              {/* </Row> */}
            </Row>
            :
            <Col className="d-flex align-items-center justify-content-center" style={{height: "60vh"}}>
            <Empty description="No data" className="fw-bold"/>
          </Col>
          }
      </Container>
    </>
  );
};

export default FavoriteList;
